import Navbar from "./components/Navbar/Navbar";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./features/Home/Home";
import About from "./features/About/About";
import MobileApp from "./features/MobileApp/MobileApp";
import WebApp from "./features/WebApp/WebApp";

function App() {
  return (
    <div className="app-container">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/webapps" element={<WebApp />} />
        <Route path="/mobileapps" element={<MobileApp />} />
      </Routes>
    </div>
  );
}

export default App;
